var _excluded = ["id", "type", "beforeNode", "afterNode", "disabled", "autoValidate", "onBlur", "onFocus", "onInvalid", "errorMessage", "helpMessage", "sizeVariant", "textInputBorderProps", "textInputProps", "squaredCornersPosition", "renderInput", "maxHeight", "dangerouslySetClassNames", "showClearButton", "onClear", "inputMinWidth"],
  _excluded2 = ["onBlur", "onFocus"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from "react";
import { useAutoId } from "../helpers";
import composeRefs from "@seznam/compose-react-refs";
import { CrossMd } from "../../components/icons";
import forwardRef from "../forwardRef";
import { Input, InputBorder, ScrollableArea, ValidationError, HelpText, ClearButton } from "./styles";
var TextInputBase = forwardRef((_ref, externalRef) => {
  var {
      id,
      type = "text",
      beforeNode,
      afterNode,
      disabled = false,
      autoValidate = true,
      onBlur,
      onFocus,
      onInvalid,
      errorMessage,
      helpMessage,
      sizeVariant = "large",
      textInputBorderProps,
      textInputProps = {},
      squaredCornersPosition = "none",
      renderInput: userRenderInput,
      maxHeight = "100px",
      dangerouslySetClassNames,
      showClearButton = false,
      onClear,
      inputMinWidth = "0"
    } = _ref,
    remainingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var [focused, setFocused] = useState(false);
  var [errorMessageText, setErrorMessageText] = useState(undefined);
  var {
      onBlur: textInputPropsOnBlur,
      onFocus: textInputPropsOnFocus
    } = textInputProps,
    remainingTextInputProps = _objectWithoutPropertiesLoose(textInputProps, _excluded2);
  var internalRef = /*#__PURE__*/React.createRef();
  var autoId = useAutoId(id);
  var validationMessageText = () => {
    return errorMessage || errorMessageText;
  };
  var showErrorMessage = !!validationMessageText();
  var showHelpMessage = !!helpMessage && !validationMessageText();
  var renderErrorMessage = () => {
    return showErrorMessage && /*#__PURE__*/React.createElement(ValidationError, {
      role: "alert",
      id: autoId + "-error",
      className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.errorMessage
    }, validationMessageText());
  };
  var renderHelpMessage = disabled => {
    return showHelpMessage && /*#__PURE__*/React.createElement(HelpText, {
      $disabled: disabled,
      id: autoId + "-help",
      className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.helpMessage
    }, helpMessage);
  };
  var renderInput = () => /*#__PURE__*/React.createElement(Input, _extends({
    disabled: disabled,
    "aria-describedby": showErrorMessage ? autoId + "-error" : showHelpMessage ? autoId + "-help" : undefined
  }, remainingProps, {
    $sizeVariant: sizeVariant,
    $inputMinWidth: inputMinWidth,
    id: autoId,
    type: type,
    onInvalid: e => {
      e.preventDefault();
      var target = e.target;
      if (autoValidate) setErrorMessageText(target.validationMessage);
      typeof onInvalid === "function" && onInvalid(e);
    },
    onFocus: e => {
      setFocused(true);
      onFocus == null || onFocus(e);
      textInputPropsOnFocus == null || textInputPropsOnFocus(e);
    },
    onBlur: e => {
      setFocused(false);
      onBlur == null || onBlur(e);
      textInputPropsOnBlur == null || textInputPropsOnBlur(e);
      if (autoValidate) setErrorMessageText(e.target.validationMessage);
    }
  }, remainingTextInputProps, {
    ref: composeRefs(textInputProps == null ? void 0 : textInputProps.ref, internalRef, externalRef),
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.input
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputBorder, _extends({
    onClick: () => {
      // TODO: Check this doesn't break other stuff
      if (internalRef.current) {
        setFocused(true);
        internalRef.current.focus();
      }
    },
    $focused: focused,
    $errored: !!validationMessageText(),
    $disabled: disabled,
    $squaredCornersPosition: squaredCornersPosition
  }, textInputBorderProps, {
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.inputBorder
  }), /*#__PURE__*/React.createElement(ScrollableArea, {
    $maxHeight: maxHeight,
    $sizeVariant: sizeVariant,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.scrollableArea
  }, beforeNode, (userRenderInput == null ? void 0 : userRenderInput({
    input: renderInput(),
    ref: internalRef
  })) || renderInput(), showClearButton && /*#__PURE__*/React.createElement(ClearButton, {
    variant: "naked",
    hideLabel: true,
    compact: true,
    $sizeVariant: sizeVariant,
    disabled: disabled,
    icon: /*#__PURE__*/React.createElement(CrossMd, null),
    onClick: onClear,
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.clearButton,
    type: "button"
  }, "Clear"), afterNode)), renderErrorMessage(), renderHelpMessage(disabled));
});
TextInputBase.displayName = "TextInputBase";
export default TextInputBase;